export type NodeColorKey = "default" | "green" | "blue" | "orange" | "yellow";

export type NodePalette = {
  background: string;
  border: string;
  text: string;
  hover: string;
};

const colorsMap: Record<NodeColorKey, NodePalette> = {
  default: {
    background: "",
    border: "",
    text: "",
    hover: "",
  },
  green: {
    background: "bg-green-500/10",
    border: "border-green-200",
    text: "text-green-600",
    hover: "hover:bg-green-500/20",
  },
  orange: {
    background: "bg-orange-500/10",
    border: "border-orange-200",
    text: "text-orange-600",
    hover: "hover:bg-orange-500/20",
  },
  blue: {
    background: "bg-blue-500/10",
    border: "border-blue-200",
    text: "text-blue-600",
    hover: "hover:bg-blue-500/20",
  },
  yellow: {
    background: "bg-yellow-500/10",
    border: "border-yellow-200",
    text: "text-yellow-600",
    hover: "hover:bg-yellow-500/20",
  },
};

export function nodeColorToTailwindClasses(color: NodeColorKey): NodePalette {
  return colorsMap[color] as NodePalette;
}
